export default __webpack_public_path__ + "static/media/instruccionesjuego4.6d143d59.png";